"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _Box = _interopRequireDefault(require("../Box"));

var _styledUtils = require("@sloth-system/styled-utils");

var _native = _interopRequireDefault(require("styled-components/native"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function RadioButton(props) {
  let Border = (0, _native.default)(_Box.default)`
    width: 20px;
    height: 20px;
    border-width: ${props.selected ? 1 : 2};
    border-color: ${(0, _styledUtils.color)("primary.main")}
    border-style: solid;
    padding:2px;
`;
  return /*#__PURE__*/_react.default.createElement(Border, {
    br: "circle",
    bg: "common.white"
  }, /*#__PURE__*/_react.default.createElement(_Box.default, {
    bg: props.selected ? "primary.main" : "common.white",
    br: "circle",
    style: {
      width: "100%",
      height: "100%"
    }
  }));
}

var _default = RadioButton;
exports.default = _default;